import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { LocalMenuGroupRouteNames, LocalMenuGroupRoutePathNames } from '../../../../enums';

const Component = () => import('./LocalBrandMenuOptimizer.vue');

export default {
  path: buildChildURL(LocalMenuGroupRoutePathNames.MENU_OPTIMIZER),
  name: LocalMenuGroupRouteNames.BRAND_MENU_OPTIMIZER,
  component: Component,
} as RouteRecordRaw;
